<template>
  <div class="search-wrap">
    <div class="search" :class="{ 'is-active': showSearchBox }">
      <router-link :to="searchUrl" class="search--link">
        <div class="icon">
          <fluent-icon icon="search" class="search--icon" size="16" />
        </div>
        <p class="search--label text-ellipsis">
          {{ $t('CONVERSATION.SEARCH_MESSAGES') }}
        </p>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
import { mapGetters } from 'vuex';

import { frontendURL } from 'dashboard/helper/URLHelper';
export default {
  directives: {
    focus: {
      inserted(el) {
        el.focus();
      },
    },
  },
  mixins: [clickaway],
  data() {
    return {
      showSearchBox: false,
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
    }),
    searchUrl() {
      return frontendURL(`accounts/${this.accountId}/search`);
    },
  },
};
</script>

<style lang="scss" scoped>
.search-wrap {
  margin-right: var(--space-minus-mega);
  position: relative;

  @media screen and (max-width: 768px) {
    display: flex;
    align-items: center;
    margin-right: var(--space-small);
    margin-left: 0;
  }
}

.search {
  display: flex;
  border-bottom: 1px solid transparent;
  margin-top: var(--space-small);

  @media screen and (max-width: 768px) {
    margin-top: 0;
  }

  &:hover {
    .search--icon,
    .search--label {
      color: var(--c-500);
    }
  }
}

.search--link {
  display: flex;
  align-items: center;
  background: var(--s-75);
  padding: var(--space-two) var(--space-larger);
  height: var(--space-medium);
  border-radius: var(--border-radius-full);
  transition: all 0.2s ease;

  @media screen and (max-width: 768px) {
    width: 40px;
    height: 40px;
    padding: 0;
    justify-content: center;
  }
}

.search--label {
  color: var(--color-body);
  margin-bottom: 0;

  @media screen and (max-width: 768px) {
    display: none;
  }
}

.search--input {
  align-items: center;
  border: 0;
  color: var(--color-body);
  cursor: pointer;
  width: 100%;
  display: flex;
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-normal);
  text-align: left;
  line-height: var(--font-size-large);
}

.search--icon {
  color: var(--s-600);
  margin: 0 var(--space-smaller);

  @media screen and (max-width: 768px) {
    width: 24px !important;
    height: 24px !important;
    margin: 0;
  }
}

.icon {
  display: flex;
}

input::placeholder {
  color: var(--color-body);
  font-size: var(--font-size-small);
}

.results-wrap {
  position: absolute;
  z-index: 9999;
  box-shadow: var(--shadow-large);
  background: white;
  width: 100%;
  max-height: 70vh;
  overflow: auto;
}

.show-results {
  list-style-type: none;
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-normal);
}

.result-view {
  display: flex;
  justify-content: space-between;
}

.result {
  padding: var(--space-smaller) var(--space-smaller) var(--space-smaller)
    var(--space-normal);
  color: var(--s-700);
  font-size: var(--font-size-medium);
  font-weight: var(--font-weight-bold);

  .message-counter {
    color: var(--s-500);
    font-size: var(--font-size-small);
    font-weight: var(--font-weight-bold);
  }
}

.search--activity-message {
  padding: var(--space-small) var(--space-normal) var(--space-small)
    var(--space-zero);
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-medium);
  color: var(--s-500);
}

.search--activity-no-message {
  display: flex;
  justify-content: center;
  padding: var(--space-one) var(--space-zero) var(--space-two) var(--space-zero);
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-medium);
  color: var(--s-500);
}
</style>
